export default __webpack_public_path__ + "static/media/home-banner2.7a7fd8ab.png";